<div [class.use-compact-theme]="compactMode">
  <app-header></app-header>

  <ngx-loading-bar></ngx-loading-bar>
  <router-outlet appIdleTimeout></router-outlet>
  <p-toast position="top-right" [baseZIndex]="5000"></p-toast>
</div>
